import { NavigationState } from './types';

export const createInitialNavState = (): NavigationState => ({
  headerHeight: 0,
  isTop: true,
});
